"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgLoading = function (props) {
    var color = props.color;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("style", null, "\n          @keyframes kf1{0%,33.33%,6.67%{transform:translate(12px,12px) rotate(-90deg) translate(-12px,-12px)}50%{transform:translate(12px,12px) rotate(15deg) translate(-12px,-12px)}60%{transform:translate(12px,12px) rotate(100deg) translate(-12px,-12px)}to{transform:translate(12px,12px) rotate(270deg) translate(-12px,-12px)}}\n\n          @keyframes kf2{0%,to{stroke-dashoffset:56.56}6.67%{stroke-dashoffset:54.282}50%,60%{stroke-dashoffset:45}}\n\n          @keyframes kf3{0%,33.33%,6.67%{stroke-dasharray:56.56}50%,to{stroke-dasharray:56.56,56.56}}"),
        react_1.default.createElement("g", { style: {
                transform: 'translate(12px,12px) rotate(-90deg) translate(-12px,-12px)',
                animationFillMode: 'backwards',
                animationName: 'kf1',
                animationTimingFunction: 'cubic-bezier(0,0,1,1)',
                animationDuration: '1s',
                animationIterationCount: 'infinite'
            }, fillRule: "evenodd", fill: "none" },
            react_1.default.createElement("circle", { cx: 12, cy: 12, r: 9, style: {
                    animationFillMode: 'backwards,backwards',
                    animationName: 'kf2,kf3',
                    animationTimingFunction: 'cubic-bezier(.42,0,1,1),cubic-bezier(0,0,1,1)',
                    animationDuration: '1s',
                    animationIterationCount: 'infinite'
                }, stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeDasharray: 56.56, strokeDashoffset: 56.56, "data-animator-group": "true", "data-animator-type": 1, transform: "rotate(-90 12 12)" }))));
};
exports.default = factorySvgIcon_1.default(SvgLoading);
//# sourceMappingURL=SvgLoading.js.map